import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const TICKETS_EASYVIEW = async (e) => {
  const res = await axios.post(BASE_URL + `/tickets/easyview/${e.ticketId}`, { pin: e.pin });
  return res.data;
};
